import { gql } from "@apollo/client"

const GET_SITE_DATA_GUARDIANS_SUMMARY = gql`
  query ($clientId: ID!) {
    dataGuardiansSummary(client_id: $clientId) {
      data_age
      imported_at
      total
      sync_count
      custom_count
      missing_student_count
    }
  }
`

export { GET_SITE_DATA_GUARDIANS_SUMMARY }
